import { render } from "./CategorySegmentTariffsView.vue?vue&type=template&id=10a2ea50"
import script from "./CategorySegmentTariffsView.vue?vue&type=script&lang=js"
export * from "./CategorySegmentTariffsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__